import { IgComment, IgMedia, IgUser2 } from '@core/models/ApiFields/ig-entities';
import { IDateRangeAsDates } from '@core/models/IDates';
import { RawDataWithBreakd } from '@core/models/IApi';
import { IG_ENDPOINT } from '../../social-listening/config/api-params';
import { HttpBuilder } from '../../social-shared/services/http/http-builder';
import { IgUserDetail } from '../../social-shared/store/ig-user-detail.store';
import { PageFiltersState } from '../../social-shared/store/page-filters.store';
import { relatedUsersFields } from '../config/user-detail.config';

export class RelatedUsersHttpBuilder extends HttpBuilder<IgUserDetail, RawDataWithBreakd> {
    reqData(state: IgUserDetail, pageFilters: PageFiltersState, igAcc: string) {
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.buildParams(pageFilters.selectedDates(), igAcc);

        state.relUsersData.set([]);
        this.makeGetReq(url, params, state);
    }

    buildParams(dates: IDateRangeAsDates, igAcc: string) {
        return {
            ...this.getDates(dates),
            ...this.getFields(),
            ...this.getBreakdowns(),
            ...this.getPagination(),
            ...this.getAccountFilter(igAcc),
            ...this.getFixedFilters(igAcc),
        };
    }

    getFields() {
        return { fields: relatedUsersFields.join() };
    }

    getBreakdowns() {
        return { breakdowns: IgMedia.getPrefixed('username') };
    }

    getPagination() {
        return {
            limit: 20,
            offset: 0,
            mode: 1,
        };
    }

    getAccountFilter(igAcc: string) {
        return {
            [IgMedia.getPrefixed('username')]: 'eq:' + igAcc,
        };
    }

    getFixedFilters(igAcc: string) {
        return {
            [IgMedia.getPrefixed('mediaType')]: 'eq:tag',
            [IgComment.getPrefixed('username')]: 'neq:' + igAcc,
            [IgUser2.getPrefixed('level')]: 'eq:1',
        };
    }

    protected override formatRes(res: any): Record<string, any>[] {
        const data = (res?.data[0] as RawDataWithBreakd)?.data;
        return data?.map(item => this.flattenOneLevel(item));
    }

    protected override handleSuccess(state: IgUserDetail, data: any): void {
        state.relUsersData.set(data);
    }
}
